import LargeDashboard from '../LargeDashboard';
import MobileDashboard from './mobile/MobileDashboard';

const DashboardContent = () => {
    const screen = window.innerWidth;
    if (screen > 500) {
        return <LargeDashboard />;
    } else {
        return <MobileDashboard />;
    }
};

export default DashboardContent;
